import styled from 'styled-components';
import { Link } from 'react-router-dom';

import { colors, transitions } from '../../../styles/theme';

interface Props {
  readonly decoration?: boolean;
  readonly fontSize?: number;
  readonly color?: string;
}

export default styled(Link)<Props>`
  font-weight: 500;
  text-decoration: ${({ decoration }: Props) => (decoration ? 'underline' : 'none')};
  color: ${({ color }: Props) => (color ? `${color}` : colors('primary.base'))};
  font-size: ${({ fontSize }: Props) => (fontSize ? `${fontSize}px` : 'initial')};
  transition: filter ${transitions('fast')};
  text-underline-offset: 3px;

  &:hover {
    transition: filter ${transitions('fast')};
    filter: ${transitions('effect.brightnessHigh')};
  }
`;
